import React from 'react';
import loadable from 'react-loadable-visibility/loadable-components';

import ValueProp from '../value-prop/value-prop-container';
import ValueProp2 from '../value-prop/value-prop-v2';
import Header from './header';
import CustomCode from '../custom-code';

const Footer = loadable(() => import('./footer'), {
    ssr: false,
});

const withHeaderFooter = Component => {
    return class extends React.PureComponent {
        render() {
            return (
                <React.Fragment>
                    <ValueProp />
                    <ValueProp2 />
                    <Header />
                    <Component {...this.state} {...this.props} />
                    <div style={{ backgroundColor: '#5a5a5a', height: 531 }}>
                        <Footer />
                    </div>
                    <CustomCode />
                </React.Fragment>
            );
        }
    };
};

export { Header, withHeaderFooter };
